import React from 'react';
import { Grid, makeStyles, Paper } from '@material-ui/core';
import OverallProgressChart from './OverallProgressChart';
import ActiveStudentsChart from './ActiveStudentsChart';
import { PrmCurriculumProgressReportResult } from 'types/schema-generated-types';
import LessonProgressChart from './LessonProgressChart';
import MaybeShowErrorMessageWithLoading from 'components/ReportsModule/components/common/MaybeShowErrorMessageWithLoading';
import useActiveStudentReport from '../../hooks/use-active-student-report';
import { isNil } from 'lodash';

type Props = {
  prmCurriculumProgressReport?: PrmCurriculumProgressReportResult;
  progressLoading?: boolean;
};

const OverallCards: React.FC<Props> = ({ prmCurriculumProgressReport, progressLoading }) => {
  const classes = useStyles();
  const [{ activeStudentsReportData }] = useActiveStudentReport();

  return (
    <Grid spacing={2} wrap="wrap" container>
      <Grid item xs={12} md={4}>
        <Paper className={classes.cards}>
          <MaybeShowErrorMessageWithLoading
            loading={progressLoading!}
            shouldRender={!isNil(prmCurriculumProgressReport?.overallProgressPercentage)}
            width="90%"
          >
            <OverallProgressChart prmCurriculumProgressReport={prmCurriculumProgressReport} />
          </MaybeShowErrorMessageWithLoading>
        </Paper>
      </Grid>
      <Grid item xs={12} md={4}>
        <Paper className={classes.cards}>
          <MaybeShowErrorMessageWithLoading
            loading={progressLoading!}
            shouldRender={!!prmCurriculumProgressReport?.curriculums?.length}
            width="90%"
          >
            <LessonProgressChart prmCurriculumProgressReport={prmCurriculumProgressReport} />
          </MaybeShowErrorMessageWithLoading>
        </Paper>
      </Grid>
      <Grid item xs={12} md={4}>
        <Paper className={classes.cards}>
          <MaybeShowErrorMessageWithLoading
            loading={progressLoading!}
            shouldRender={!isNil(activeStudentsReportData?.prmActiveStudentsReport)}
            width="90%"
          >
            <ActiveStudentsChart
              activeStudentsReportData={activeStudentsReportData?.prmActiveStudentsReport!}
            />
          </MaybeShowErrorMessageWithLoading>
        </Paper>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles(() => ({
  cards: {
    display: 'flex',
    justifyContent: 'center',
    flex: 1,
    height: 232
  },
  skeleton: {
    margin: '0px 32px'
  }
}));
export default OverallCards;
